import axios from '../utils/axios';

// Same endpoint as fetchAllJobs, but over POST. jobId can be a very long comma
// separated list which overflows the URL length limit (414) on a GET, so it is
// sent in the body. Every other parameter still goes as a query param.
export default function fetchAllJobsPost(adminId, params) {
    const { jobId, ...queryParams } = params;
    return (
        axios.post('/admin/' + adminId + '/all-jobs', { jobId }, {
            params: queryParams
        })
        .then(res => {
            return res.data
        })
        .catch(err => {
            return err;
        })
    )
}
